// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as BillingRouteImport } from './routes/billing'
import { Route as GuideRouteImport } from './routes/guide'
import { Route as LoginRouteImport } from './routes/login'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as PaymentSuccessRouteImport } from './routes/payment-success'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AdminAnnouncementsRouteImport } from './routes/admin/announcements'
import { Route as AdminClassesRouteImport } from './routes/admin/classes'
import { Route as AdminDocumentsRouteImport } from './routes/admin/documents'
import { Route as AdminHelpRouteImport } from './routes/admin/help'
import { Route as AdminMyAssignmentsRouteImport } from './routes/admin/my-assignments'
import { Route as AdminMyAttendanceRouteImport } from './routes/admin/my-attendance'
import { Route as AdminMyScheduleRouteImport } from './routes/admin/my-schedule'
import { Route as AdminReportsRouteImport } from './routes/admin/reports'
import { Route as AdminStudentsRouteImport } from './routes/admin/students'
import { Route as AuthCallbackRouteImport } from './routes/auth/callback'
import { Route as StudentIndexRouteImport } from './routes/student/index'
import { Route as StudentAssignmentsRouteImport } from './routes/student/assignments'
import { Route as StudentAttendanceRouteImport } from './routes/student/attendance'
import { Route as StudentClassesRouteImport } from './routes/student/classes'
import { Route as StudentDocumentsRouteImport } from './routes/student/documents'
import { Route as StudentHelpRouteImport } from './routes/student/help'
import { Route as StudentScheduleRouteImport } from './routes/student/schedule'
import { Route as TeacherIndexRouteImport } from './routes/teacher/index'
import { Route as TeacherAnalyticsRouteImport } from './routes/teacher/analytics'
import { Route as TeacherAnnouncementsRouteImport } from './routes/teacher/announcements'
import { Route as TeacherAssignmentsRouteImport } from './routes/teacher/assignments'
import { Route as TeacherAttendanceRouteImport } from './routes/teacher/attendance'
import { Route as TeacherDocumentsRouteImport } from './routes/teacher/documents'
import { Route as TeacherGradingRouteImport } from './routes/teacher/grading'
import { Route as TeacherHelpRouteImport } from './routes/teacher/help'
import { Route as TeacherScheduleRouteImport } from './routes/teacher/schedule'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const BillingRoute = BillingRouteImport.update({
            id: '/billing',path: '/billing',getParentRoute: () => rootRouteImport
          })
const GuideRoute = GuideRouteImport.update({
            id: '/guide',path: '/guide',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const OnboardingRoute = OnboardingRouteImport.update({
            id: '/onboarding',path: '/onboarding',getParentRoute: () => rootRouteImport
          })
const PaymentSuccessRoute = PaymentSuccessRouteImport.update({
            id: '/payment-success',path: '/payment-success',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const SettingsRoute = SettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => rootRouteImport
          })
const SignupRoute = SignupRouteImport.update({
            id: '/signup',path: '/signup',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/admin/',path: '/admin/',getParentRoute: () => rootRouteImport
          })
const AdminAnnouncementsRoute = AdminAnnouncementsRouteImport.update({
            id: '/admin/announcements',path: '/admin/announcements',getParentRoute: () => rootRouteImport
          })
const AdminClassesRoute = AdminClassesRouteImport.update({
            id: '/admin/classes',path: '/admin/classes',getParentRoute: () => rootRouteImport
          })
const AdminDocumentsRoute = AdminDocumentsRouteImport.update({
            id: '/admin/documents',path: '/admin/documents',getParentRoute: () => rootRouteImport
          })
const AdminHelpRoute = AdminHelpRouteImport.update({
            id: '/admin/help',path: '/admin/help',getParentRoute: () => rootRouteImport
          })
const AdminMyAssignmentsRoute = AdminMyAssignmentsRouteImport.update({
            id: '/admin/my-assignments',path: '/admin/my-assignments',getParentRoute: () => rootRouteImport
          })
const AdminMyAttendanceRoute = AdminMyAttendanceRouteImport.update({
            id: '/admin/my-attendance',path: '/admin/my-attendance',getParentRoute: () => rootRouteImport
          })
const AdminMyScheduleRoute = AdminMyScheduleRouteImport.update({
            id: '/admin/my-schedule',path: '/admin/my-schedule',getParentRoute: () => rootRouteImport
          })
const AdminReportsRoute = AdminReportsRouteImport.update({
            id: '/admin/reports',path: '/admin/reports',getParentRoute: () => rootRouteImport
          })
const AdminStudentsRoute = AdminStudentsRouteImport.update({
            id: '/admin/students',path: '/admin/students',getParentRoute: () => rootRouteImport
          })
const AuthCallbackRoute = AuthCallbackRouteImport.update({
            id: '/auth/callback',path: '/auth/callback',getParentRoute: () => rootRouteImport
          })
const StudentIndexRoute = StudentIndexRouteImport.update({
            id: '/student/',path: '/student/',getParentRoute: () => rootRouteImport
          })
const StudentAssignmentsRoute = StudentAssignmentsRouteImport.update({
            id: '/student/assignments',path: '/student/assignments',getParentRoute: () => rootRouteImport
          })
const StudentAttendanceRoute = StudentAttendanceRouteImport.update({
            id: '/student/attendance',path: '/student/attendance',getParentRoute: () => rootRouteImport
          })
const StudentClassesRoute = StudentClassesRouteImport.update({
            id: '/student/classes',path: '/student/classes',getParentRoute: () => rootRouteImport
          })
const StudentDocumentsRoute = StudentDocumentsRouteImport.update({
            id: '/student/documents',path: '/student/documents',getParentRoute: () => rootRouteImport
          })
const StudentHelpRoute = StudentHelpRouteImport.update({
            id: '/student/help',path: '/student/help',getParentRoute: () => rootRouteImport
          })
const StudentScheduleRoute = StudentScheduleRouteImport.update({
            id: '/student/schedule',path: '/student/schedule',getParentRoute: () => rootRouteImport
          })
const TeacherIndexRoute = TeacherIndexRouteImport.update({
            id: '/teacher/',path: '/teacher/',getParentRoute: () => rootRouteImport
          })
const TeacherAnalyticsRoute = TeacherAnalyticsRouteImport.update({
            id: '/teacher/analytics',path: '/teacher/analytics',getParentRoute: () => rootRouteImport
          })
const TeacherAnnouncementsRoute = TeacherAnnouncementsRouteImport.update({
            id: '/teacher/announcements',path: '/teacher/announcements',getParentRoute: () => rootRouteImport
          })
const TeacherAssignmentsRoute = TeacherAssignmentsRouteImport.update({
            id: '/teacher/assignments',path: '/teacher/assignments',getParentRoute: () => rootRouteImport
          })
const TeacherAttendanceRoute = TeacherAttendanceRouteImport.update({
            id: '/teacher/attendance',path: '/teacher/attendance',getParentRoute: () => rootRouteImport
          })
const TeacherDocumentsRoute = TeacherDocumentsRouteImport.update({
            id: '/teacher/documents',path: '/teacher/documents',getParentRoute: () => rootRouteImport
          })
const TeacherGradingRoute = TeacherGradingRouteImport.update({
            id: '/teacher/grading',path: '/teacher/grading',getParentRoute: () => rootRouteImport
          })
const TeacherHelpRoute = TeacherHelpRouteImport.update({
            id: '/teacher/help',path: '/teacher/help',getParentRoute: () => rootRouteImport
          })
const TeacherScheduleRoute = TeacherScheduleRouteImport.update({
            id: '/teacher/schedule',path: '/teacher/schedule',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,BillingRoute: BillingRoute,GuideRoute: GuideRoute,LoginRoute: LoginRoute,OnboardingRoute: OnboardingRoute,PaymentSuccessRoute: PaymentSuccessRoute,PrivacyRoute: PrivacyRoute,SettingsRoute: SettingsRoute,SignupRoute: SignupRoute,TermsRoute: TermsRoute,AdminAnnouncementsRoute: AdminAnnouncementsRoute,AdminClassesRoute: AdminClassesRoute,AdminDocumentsRoute: AdminDocumentsRoute,AdminHelpRoute: AdminHelpRoute,AdminMyAssignmentsRoute: AdminMyAssignmentsRoute,AdminMyAttendanceRoute: AdminMyAttendanceRoute,AdminMyScheduleRoute: AdminMyScheduleRoute,AdminReportsRoute: AdminReportsRoute,AdminStudentsRoute: AdminStudentsRoute,AuthCallbackRoute: AuthCallbackRoute,StudentAssignmentsRoute: StudentAssignmentsRoute,StudentAttendanceRoute: StudentAttendanceRoute,StudentClassesRoute: StudentClassesRoute,StudentDocumentsRoute: StudentDocumentsRoute,StudentHelpRoute: StudentHelpRoute,StudentScheduleRoute: StudentScheduleRoute,TeacherAnalyticsRoute: TeacherAnalyticsRoute,TeacherAnnouncementsRoute: TeacherAnnouncementsRoute,TeacherAssignmentsRoute: TeacherAssignmentsRoute,TeacherAttendanceRoute: TeacherAttendanceRoute,TeacherDocumentsRoute: TeacherDocumentsRoute,TeacherGradingRoute: TeacherGradingRoute,TeacherHelpRoute: TeacherHelpRoute,TeacherScheduleRoute: TeacherScheduleRoute,AdminIndexRoute: AdminIndexRoute,StudentIndexRoute: StudentIndexRoute,TeacherIndexRoute: TeacherIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)